export default "__VITE_ASSET__D2Jg0bYu__"